import type { MapCameraChangedEvent } from "@vis.gl/react-google-maps";
import { useCallback } from "react";
import { useMapControlAtomState } from "./mapControlAtom";

export const useMapController = () => {
    const [mapControl, setMapControl] = useMapControlAtomState();

    const handleCameraChange = useCallback(
        ({ detail }: MapCameraChangedEvent) => {
            setMapControl({
                ...mapControl,
                camera: {
                    center: detail.center,
                    zoom: detail.zoom,
                },
            });
        },
        [mapControl],
    );

    return {
        camera: mapControl.camera,
        handleCameraChange,
    };
};
